module.exports = __webpack_public_path__ + "pic2.ce0a0a9daa5634f8aead.jpg";


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/assets/img/pic2.jpg
// module id = ../../../../../src/assets/img/pic2.jpg
// module chunks = main